import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const coralogix = defineConnector({
  identifier: "coralogix",
  name: "Coralogix",
  tagLine: "Observability and log analytics",
  logo,
  protocol: "http",
  tags: ["observability"],
  defaultUrlPattern: () => "https://api\\..*\\.coralogix\\.(com|us|in)/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.apiKey,
        scheme: "Bearer",
      },
    ]),
  steps: [
    {
      title: "Select your region and get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In your Coralogix dashboard, go to **Data Flow > API Keys** and create a new key with the permissions you need.",
        },
        {
          kind: "select",
          label: "Region",
          required: true,
          defaultValue: "coralogix.com",
          target: { kind: "configuration", field: "domain" },
          options: [
            {
              value: "coralogix.com",
              label: "EU1 – Ireland (coralogix.com)",
            },
            {
              value: "eu2.coralogix.com",
              label: "EU2 – Stockholm (eu2.coralogix.com)",
            },
            { value: "coralogix.us", label: "US1 – Ohio (coralogix.us)" },
            {
              value: "cx498.coralogix.com",
              label: "US2 – Virginia (cx498.coralogix.com)",
            },
            {
              value: "coralogix.in",
              label: "AP1 – Mumbai (coralogix.in)",
            },
            {
              value: "coralogixsg.com",
              label: "AP2 – Singapore (coralogixsg.com)",
            },
            {
              value: "ap3.coralogix.com",
              label: "AP3 – Sydney (ap3.coralogix.com)",
            },
          ],
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) =>
      `https://api.${domain}/mgmt/openapi/latest/aaa/api-keys/v3/send-data`,
  },
  publicEnvVars: ({ domain }) => ({ CORALOGIX_DOMAIN: domain || "" }),
});
